export const INSTAGRAM_URL = "https://www.instagram.com/lootstack.app/";
export const FACEBOOK_URL = "https://www.facebook.com/lootstack";
export const X_USERNAME = "lootstackapp";
export const X_HANDLE = `@${X_USERNAME}`;
export const X_URL = `https://x.com/${X_USERNAME}`;
